// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1CLNH","inputDescription":"styles_inputDescription__1l9TU"};